import { WorkAPI } from './API'
import { Task } from './Job'
import { PrimeJob } from './JobStore'
import { Id } from 'types/definitions'
import {
  CompleteTaskRequest,
  GetJobRequest,
  UncompleteTaskRequest,
} from '@taxfyle/api-internal/internal/job_pb'
import { mapJobProtoToJobDTO } from './dtos/jobGrpcDtoMapper'
import { JobProtoDTO } from './dtos/job'

export default class MilestoneStore {
  constructor(
    private api: WorkAPI,
    private primeJob: PrimeJob,
  ) {}

  async complete(task: Task) {
    const jobId = Id.assert(task.job.id)
    const request = new CompleteTaskRequest().setJobId(jobId).setTaskId(task.id)

    return this.api.jobsV3
      .completeTask(request)
      .then(() => this.api.jobsV3.getJob(new GetJobRequest().setId(jobId)))
      .then((jobProto) =>
        mapJobProtoToJobDTO(jobProto.toObject() as JobProtoDTO),
      )
      .then((j) =>
        this.primeJob({
          id: j.id,
          milestones: j.milestones,
          date_modified: j.date_modified,
        }),
      )
  }

  async uncomplete(task: Task) {
    const jobId = Id.assert(task.job.id)
    const request = new UncompleteTaskRequest()
      .setJobId(jobId)
      .setTaskId(task.id)

    return this.api.jobsV3
      .uncompleteTask(request)
      .then(() => this.api.jobsV3.getJob(new GetJobRequest().setId(jobId)))
      .then((jobProto) =>
        mapJobProtoToJobDTO(jobProto.toObject() as JobProtoDTO),
      )
      .then((j) =>
        this.primeJob({
          id: j.id,
          milestones: j.milestones,
          date_modified: j.date_modified,
        }),
      )
  }
}
